export default "__VITE_ASSET__DOKDyBwv__"